import React, {useCallback, useEffect, useRef, useState} from 'react';
import {useDispatch} from 'react-redux';


import {GroupSuggest} from 'src/components/group-suggest';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {
    applyUpdatedData,
    setGroup,
} from 'src/modules/create-user/user-bulk-import/services/user-bulk-import.slice';

import {FlatButton} from '@pb/kit-component-button';
import {Dropdown} from '@pb/kit-component-dropdown';
import {Group} from '@pb/kit-component-group';

import type {AccountGroup} from 'src/openapi/admin/models/AccountGroup';

type Props = {
    accountId: number,
    selectedRecordIds: number[],
};

export const SetGroup = ({accountId, selectedRecordIds}: Props) => {
    const dispatch = useDispatch();
    const {userFieldChange} = useEventTracking();
    const [dropdownShown, setDropdownShown] = useState(false);
    const closeTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

    const closeDropdown = useCallback(() => {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
        }

        closeTimeoutRef.current = setTimeout(() => {
            setDropdownShown(false);
            closeTimeoutRef.current = null;
        });
    }, []);

    useEffect(() => () => {
        if (closeTimeoutRef.current) {
            clearTimeout(closeTimeoutRef.current);
        }
    }, []);

    const selectGroup = useCallback((group: AccountGroup | null) => {
        dispatch(applyUpdatedData());
        dispatch(setGroup({ids: selectedRecordIds, group}));

        userFieldChange({
            section: 'Validate File',
            parameterName: 'Group',
            viewType: 'Bulk Import Users',
        });

        closeDropdown();
    }, [selectedRecordIds, dispatch, userFieldChange, closeDropdown]);

    return (
        <Group>
            <Dropdown
                shown={dropdownShown}
                setShown={setDropdownShown}
                anchor={({anchorRef, getAnchorProps}) => (
                    <FlatButton
                        ref={node => {
                            if (typeof anchorRef === 'function') {
                                anchorRef(node);
                            }
                        }}
                        {...getAnchorProps()}>
                        <b>Set Group</b>
                    </FlatButton>
                )}>
                <GroupSuggest
                    width={200}
                    id="group-filter-suggest"
                    placeholder="Group"
                    accountId={accountId}
                    onSelect={selectGroup}
                />
            </Dropdown>
        </Group>
    );
};
